<template>
  <div
    class="field"
    :class="additionalClasses"
  >
    <label :for="_uid">{{ label }}</label>
    <ValidationProvider
      v-slot="{ validate, errors }"
      :rules="rules"
    >
      <div class="select">
        <region-select
          :id="_uid"
          :value="value"
          :required="required"
          placeholder=""
          :class="{'error': errors.length}"
          :country="country"
          :region="value"
          @blur="validate"
          @input="$emit('input', $event), validate($event)"
        />
      </div>
      <div v-if="errors.length" class="error__text">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
    <pre style="display: none">{{ value }}</pre>
  </div>
</template>

<script>
import usesValidation from '@/mixins/veeValidate'
export default {

  name: 'DSRegionSelect',

  mixins: [
    usesValidation,
  ],

  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: 'required',
    },
    value: {
      type: String,
      default: '',
    },
    country: {
      type: String,
      default: '',
    },
  },

  computed: {
    additionalClasses() {
      return {
        required: this.required,
      }
    },
  },
}
</script>
